import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboSalaExtraccion`, method: 'GET', body: null, token: token})
}
